import { PageViewEventLogger } from '@repo/tracking-service';
import { ReactElement } from 'react';

import { AllLocationsContainer } from '@/components/survey/business/first-location/AllLocationsContainer';
import { BusinessProvider } from '@/components/survey/common/BusinessProvider';
import { LocationProvider } from '@/components/survey/common/LocationProvider';
import { SurveyProvider } from '@/components/survey/common/SurveyProvider';
import { useSurveyUserEventAttributes } from '@/components/survey/common/hooks/use-survey-user-event-attributes';

function AllLocationsPage() {
  const eventAttributes = useSurveyUserEventAttributes();

  return (
    <PageViewEventLogger pageName={'survey_relocation-address-register'} eventProperty={eventAttributes}>
      <AllLocationsContainer />
    </PageViewEventLogger>
  );
}

AllLocationsPage.getLayout = (page: ReactElement) => (
  <SurveyProvider>
    <BusinessProvider>
      <LocationProvider>{page}</LocationProvider>
    </BusinessProvider>
  </SurveyProvider>
);

export default AllLocationsPage;
